import dynamic from 'next/dynamic';
import { copyToClipboard } from '@scale/frontend-lib/clipboard';
import React from 'react';
const ReactJsonViewBase = dynamic(() => import('react-json-view'), { ssr: false });

export const ReactJsonView: React.FC<IJSONViewProps> = props => {
  const resolvedEnableClipboard =
    props.enableClipboard === true
      ? ({ src }: { src: any }) => {
          const serialized = typeof src === 'string' ? src : JSON.stringify(src);
          copyToClipboard(serialized, { copyRaw: true });
        }
      : props.enableClipboard || false;

  return <ReactJsonViewBase {...props} enableClipboard={resolvedEnableClipboard} />;
};
